import { FC } from 'react'

import { ISvgClass } from '../interface'

const HamburguerIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M8 12H16M6 8H18M6 16H18"
        stroke="#080808"
        stroke-width="1.5"
        stroke-linecap="round"
        fill="inherit"
      />
    </svg>
  )
}

export default HamburguerIcon
